<template>
  <div>
    <i class="fas fa-circle" v-if="params.value > '0'" :class="{ 'initialized': params.value === '2', 'finished': params.value === '3', 'notInitialized': params.value === '1' }"></i>
    {{ pdrStatus }}
  </div>
</template>

<script>
export default {
  name: 'pdrDepartamentoStatusRenderer',
  computed: {
    pdrStatus () {
      return this.$lang.PCI.PDR.StatusDepartament['_' + this.params.value]
    }
  }
}
</script>

<style scoped>
  .fas {
    font-size: 15px;
    text-shadow: -1px 1px 2px black;
  }

  .initialized {
    color: yellow;
  }

  .finished {
    color: green;
  }

  .notInitialized {
    color: tomato;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/PdrDepartamentoStatusRenderer.vue